import { render, staticRenderFns } from "./SendMailMailClientButton.vue?vue&type=template&id=2065b3cd"
import script from "./SendMailMailClientButton.vue?vue&type=script&lang=ts"
export * from "./SendMailMailClientButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports